import type { ExperimentPipeline, PipelineStage } from 'types';

/** What the collision endpoints report. Mirrors src/servers/api/pipelines/collisions.ts. */
export type CollisionVerdict = 'safe' | 'allow' | 'warn' | 'block';

export type Collision = {
  verdict: CollisionVerdict;
  kind: 'none' | 'disjoint-devices' | 'disjoint-urls' | 'selector' | 'redirect' | 'shared-goal';
  reason: string;
  detail: string[];
};

export type PairCollision = {
  aId: number;
  aName: string;
  bId: number;
  bName: string;
  collision: Collision;
};

export type StageCollisions = {
  stageId: number | null;
  stageIndex: number;
  worst: CollisionVerdict;
  pairs: PairCollision[];
};

export type PipelineBoardResponse = {
  pipeline: ExperimentPipeline;
  collisions: StageCollisions[];
};

/** A stage as the editor holds it: server ids where they exist, null where they do not. */
export type StageDraft = {
  /** Null until saved. The server assigns the id and the next load carries it. */
  id: number | null;
  name: string;
  advanceRule: PipelineStage['advanceRule'];
  /** 'pending' for a stage the editor invented; the server owns every other value. */
  state: PipelineStage['state'];
  experimentIds: number[];
};

/** The payload PUT /pipelines/:id/board accepts. Positions come from array order. */
export type BoardPayloadStage = {
  id: number | null;
  name: string;
  advanceRule: PipelineStage['advanceRule'];
  experimentIds: number[];
};

export const isFrozen = (stage: StageDraft): boolean => stage.state !== 'pending';
